
function urlBase64ToUint8Array(base64String: string) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

export const isPushSupported = (): boolean => {
    return 'serviceWorker' in navigator && 'PushManager' in window;
};

export const getSubscription = async (): Promise<PushSubscription | null> => {
    if (!isPushSupported()) return null;
    const registration = await navigator.serviceWorker.ready;
    return registration.pushManager.getSubscription();
};

export const subscribeUser = async (vapidKey: string): Promise<PushSubscription> => {
    if (!isPushSupported()) {
        throw new Error('Push notifications are not supported by this browser.');
    }
    if (!vapidKey) {
        throw new Error('VAPID key is not configured for push notifications.');
    }

    const registration = await navigator.serviceWorker.ready;
    const existingSubscription = await registration.pushManager.getSubscription();
    if (existingSubscription) {
        return existingSubscription;
    }

    const permission = await window.Notification.requestPermission();
    if (permission !== 'granted') {
        throw new Error('Push notification permission was not granted.');
    }

    const applicationServerKey = urlBase64ToUint8Array(vapidKey);
    const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey,
    });
    
    return subscription;
};

export const unsubscribeUser = async (): Promise<boolean> => {
    const subscription = await getSubscription();
    if (subscription) {
        return await subscription.unsubscribe();
    }
    return true; // Already unsubscribed
};
